import { makeObservable, observable } from 'mobx'
import { EMPTY_NUMBER_ID } from 'src/constant/common'
import ExtendedMap from 'src/models/ExtendedMap'

import { Student } from '../index'
import { SchoolGrade } from './SchoolGrade'

type ConstructorParams = {
  id?: number
  name?: string
  grade?: res.Student['grade']
  schoolType?: res.Student['schoolType']
  memberList: {
    id: res.Student['id']
    name: res.Student['name']
    email: res.StudentDetail['email']
    attendance: {
      id: number
      status: 'QUIT' | 'ENTER'
    } | null
  }[]
}

// TODO: 이거 쓰는곳 다 지우고 StudentGroups + AttendanceByStudentId로 변경
// 출석 정보가 있는 (반, 학년)별 학생 그룹
// Deprecated
export class StudentGroupWithAttendance {
  id: number = EMPTY_NUMBER_ID
  memberColl: ExtendedMap<Student['id'], ConstructorParams['memberList'][number]>
  schoolGrade?: SchoolGrade
  name?: string

  constructor(data: ConstructorParams) {
    makeObservable(this, {
      name: observable,
      id: observable,
    })

    this.memberColl = ExtendedMap.fromArr(data.memberList, 'id')
    if (data.id) this.id = data.id
    if (data.name) this.name = data.name
    if (data.grade && data.schoolType) {
      this.schoolGrade = new SchoolGrade({ grade: data.grade, schoolType: data.schoolType })
    }
  }

  get memberList() {
    return [...this.memberColl.values()]
  }

  get groupId() {
    return this.schoolGrade ? this.schoolGrade.koLabel : this.id
  }

  get groupName() {
    return this.name ? this.name : this.schoolGrade?.koLabel
  }

  get groupType() {
    return this.name ? 'lesson-class' : 'grade'
  }
}
